import type { Country } from '@/shared/types';
import {
  type PhoneFormValues,
  usePhoneForm,
} from '@/widgets/phone-verification';
import {
  type SendMfaOtpCodeResponseDto,
  useSendTwoFactorIdentityCode,
} from '@/features/user-settings-phone/api';
import type { PhoneVerificationTwoFactorIdentityModalArgs } from '@/features/user-settings-phone/model/types.ts';

const usePhoneVerificationForm = (
  countriesData: Country[] | undefined,
  onSuccess?: (data: PhoneVerificationTwoFactorIdentityModalArgs) => void,
  identity?: string
) => {
  const { form } = usePhoneForm(countriesData, {
    phone: identity,
  });

  const handleSuccess = (data: SendMfaOtpCodeResponseDto) => {
    if (onSuccess) {
      onSuccess({
        ...data,
        identity:
          identity ??
          form.getValues('countryCode') + form.getValues('phoneNumber'),
        identityType: 'phone',
      });
    }
  };

  const {
    sendTwoFactorIdentityError,
    sendTwoFactorIdentity,
    isSendTwoFactorIdentityLoading,
  } = useSendTwoFactorIdentityCode({
    onSuccess: handleSuccess,
  });

  const onSubmit = async (data: PhoneFormValues) => {
    await sendTwoFactorIdentity({
      identity: data.countryCode + data.phoneNumber,
      identityType: 'phone',
    });
  };

  return {
    form: form,
    onSubmit,
    isSendTwoFactorIdentityLoading,
    sendTwoFactorIdentityError,
  };
};

export { usePhoneVerificationForm };
